import { Component, Input } from '@angular/core';
import { HomeHeroSlide } from '../models/home.models';

@Component({
  standalone: false,
  selector: 'app-home-hero',
  templateUrl: './home-hero.component.html',
  styleUrls: ['./home-hero.component.scss'],
})
export class HomeHeroComponent {
  @Input({ required: true }) slides: HomeHeroSlide[] = [];

  activeSlideIndex = 0;

  get activeSlide(): HomeHeroSlide | null {
    return this.slides[this.activeSlideIndex] ?? null;
  }

  get showDots(): boolean {
    return this.slides.length > 1;
  }

  selectSlide(index: number): void {
    if (index < 0 || index >= this.slides.length) {
      return;
    }

    this.activeSlideIndex = index;
  }

  trackSlide(_index: number, slide: HomeHeroSlide): string {
    return slide.id;
  }

  trackStat(_index: number, stat: { label: string }): string {
    return stat.label;
  }
}
